import { useTranslation } from "react-i18next";
import { useEnhancedTranslation } from "@/hooks/useEnhancedTranslation";

export function useTranslationWrapper() {
  const { t } = useTranslation();
  const enhancedTranslation = useEnhancedTranslation();
  
  const translateWrapper = (key: string, fallback?: string): string => {
    // Try with the enhanced translation first
    const enhancedResult = enhancedTranslation.t(key, fallback);
    
    // If it's just returning the key and we have a fallback, use the fallback
    if (enhancedResult === key && fallback) {
      return fallback;
    }
    
    // Otherwise return the enhanced result
    return enhancedResult;
  };
  
  return {
    translateWrapper
  };
}
